/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reportAppMessageAction} from '../api'

export const useMutationReportAppMessageAction = createReactQueryMutationHook('reportAppMessageAction', reportAppMessageAction)
